import CustomProvider from 'components/CustomProvider';
import RecurlyAccountStatus from 'types/RecurlyAccountStatus';
import ExpirationDate from './ExpirationDate';
import RenewalDate from './RenewalDate';
import ProSubscriberSince from './ProSubscriberSince';

type Props = {
  activeSubscription: boolean;
  isAppleSubscription: boolean;
  recurlyAccountStatus: RecurlyAccountStatus;
};

function RenewalAndExpirationDate({ activeSubscription, isAppleSubscription, recurlyAccountStatus }: Props) {
  return (
    <CustomProvider>
      {activeSubscription ? (
        <RenewalDate recurlyAccountStatus={recurlyAccountStatus} />
      ) : (
        <ExpirationDate isAppleSubscription={isAppleSubscription} />
      )}
      <ProSubscriberSince />
    </CustomProvider>
  );
}

export default RenewalAndExpirationDate;
